module.exports = {"430981006":"琼湖街道","430981008":"胭脂湖街道","430981102":"四季红镇","430981105":"泗湖山镇","430981107":"南嘴镇","430981108":"新湾镇","430981110":"茶盘洲镇","430981112":"南大膳镇","430981113":"黄茅洲镇","430981114":"草尾镇","430981115":"阳罗洲镇","430981116":"共华镇","430981401":"南洞庭芦苇场","430981402":"漉湖芦苇场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430981.json
// module id = 1891
// module chunks = 0